import { resolveWorksheetStrictness } from './worksheetStrictness'

const stableStringify = (value: any): string => {
  const seen = new WeakSet<object>()
  const normalize = (current: any): any => {
    if (current === null || typeof current === 'undefined') return current
    if (typeof current === 'bigint') return current.toString()
    if (typeof current !== 'object') return current
    if (seen.has(current as object)) return '[Circular]'
    seen.add(current as object)
    if (Array.isArray(current)) return current.map(normalize)
    const out: Record<string, any> = {}
    for (const key of Object.keys(current).sort()) out[key] = normalize(current[key])
    return out
  }
  try {
    return JSON.stringify(normalize(value))
  } catch {
    return String(value ?? '')
  }
}

const summarizeError = (error: unknown): string | null => {
  const message = String((error as any)?.message ?? error ?? '').trim()
  return message ? message.slice(0, 400) : null
}

export const buildFailFastInvariantMessage = (input: {
  name: string
  details?: Record<string, any> | null
  error?: unknown
}): string => {
  const name = String(input.name ?? '').trim() || 'worksheet_invariant_failed'
  const details = input.details && typeof input.details === 'object' ? input.details : null
  const errorMessage = summarizeError(input.error)
  const suffixParts: string[] = []
  if (details) suffixParts.push(`details=${stableStringify(details)}`)
  if (errorMessage) suffixParts.push(`error=${errorMessage}`)
  return suffixParts.length > 0
    ? `[FG-FAIL-FAST:${name}] ${suffixParts.join(' ')}`
    : `[FG-FAIL-FAST:${name}]`
}

export const failFastInvariant = (input: {
  name: string
  details?: Record<string, any> | null
  error?: unknown
  strictNoFallbacks?: boolean
}): never => {
  const message = buildFailFastInvariantMessage(input)
  const strictNoFallbacks =
    typeof input.strictNoFallbacks === 'boolean'
      ? input.strictNoFallbacks
      : resolveWorksheetStrictness().strictNoFallbacks
  if (!strictNoFallbacks) {
    console.warn(message)
  }
  throw new Error(message)
}

export const assertFailFastInvariant = (
  condition: unknown,
  input: {
    name: string
    details?: Record<string, any> | null
    error?: unknown
    strictNoFallbacks?: boolean
  },
): void => {
  if (condition) return
  failFastInvariant(input)
}

